/**
 * 원본 `File` 객체 없이도 Editor Import를 재개할 수 있는지 판정합니다.
 *
 * STUDIO-ASSET-003 정본은 Home·다른 `.viewr`·다른 Space에서 `Tap to import to Space.`를
 * 누르면 "원래 `.viewr`와 target Space를 열어 로드를 계속한다"고 정의하며, 이 규칙을
 * `editor_object_import`와 `editor_library_attach` 양쪽에 적용합니다. 허용되는 실패는
 * "target Space가 삭제·재정렬되어 캡처한 대상을 검증할 수 없는" 경우뿐입니다.
 *
 * 그런데 pre-submit 방어(`!hasUploadRuntimeControl`)는 원래 **로컬에서 업로드한 원본
 * `File`을 hard reload 뒤 되살릴 수 없는** 경우를 위한 것입니다. Revision 프로젝트의
 * Library import는 `flow: editor_object_import` + `remotePhase: not_submitted`로 기록되지만
 * 시작 시점부터 서버측 입력을 갖고 있어 원본 `File`이 필요하지 않습니다. 그래서 이
 * 방어에 걸려 `File is no longer available.`로 실패했습니다.
 * (사용자 확인 2026-09-22 · STG build 1790037047334 · `Untitled (20)`)
 *
 * 판정 기준은 `dispatchRestoreImport`가 실제로 소비하는 입력과 같습니다. 그쪽 입력
 * 해석이 바뀌면 이 predicate도 함께 고쳐야 합니다.
 */
export const canResumeEditorImportWithoutOriginalFile = (
  item: {
    platformFiles?: unknown[] | null;
    gcsPath?: string | null;
    convertedDownloadUrl?: string | null;
    fileUrl?: string | null;
  } | null
    | undefined,
): boolean =>
  Boolean(
    item &&
      (item.platformFiles?.length ||
        item.gcsPath ||
        item.convertedDownloadUrl ||
        item.fileUrl),
  );
